import { COUNTRY_CODE } from '@/utils/constants';
import { PHASE } from '../utils/constants';

const DEFAULT_PHASE_COLOR = '';

/** AU and NZ */
const ANZ_PHASE_COLOR = {
  [PHASE.L1]: '#ed2024',
  [PHASE.L2]: '#ffffff',
  [PHASE.L3]: '#3953a4',
};

/** UK and Ireland */
const UKI_PHASE_COLOR = {
  [PHASE.L1]: '#8c6339',
  [PHASE.L2]: '#000000',
  [PHASE.L3]: '#939598',
};

/**
 * Return the phase color based on the country and phase.
 *
 * @param country
 * @param phase L1, L2, or L3
 * @returns The hex code of the phase color, or empty string if no match.
 */
export const getPhaseColor = (country: COUNTRY_CODE, phase: PHASE) => {
  switch (country) {
    case COUNTRY_CODE.Australia:
    case COUNTRY_CODE['New Zealand']:
      return ANZ_PHASE_COLOR[phase];
    case COUNTRY_CODE['United Kingdom']:
    case COUNTRY_CODE.Germany:
      return UKI_PHASE_COLOR[phase];
    default:
      return DEFAULT_PHASE_COLOR;
  }
};
